import { render, staticRenderFns } from "./TsDatastoreUpdateDialog.vue?vue&type=template&id=6781a004&"
import script from "./TsDatastoreUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./TsDatastoreUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports